import { Entity } from "src/app/helpers/entity";

export class Loantransaction implements Entity {

    Id : number;
    TransactionNo: number;
    LoanId : number;
    CentreId : number;
    TransactionDate   : String;
    CollectionAmount : number;
    PrincipleAmount : number;
    InterestAmount   : number;
    BalanceAmount : number;
    InstallmentNo : number;
    IsPartPayment : boolean;
    IsLoanPreclosure : boolean;
    IsDeath : boolean;
    IsReceiptAmount : boolean;
    PaymentTypeId: number;
    PaymentBankId : number;
    ChequeNo : string;
    Remarks  : string;

    EmployeeId  : number;
    EmployeeBranchId  : number;
    CompanyId  : number;
    SaasId  : number;
    CreatedDate  : Date;
    ModifiedDate  : Date;
    IsActive : boolean;
    Flag: Number;

    ListByCentreId : boolean;

    CustomerName : string;
    LoanApprovedDate  : Date;
    LoanDemand  : number;
    TotalDemand  : number;
    SavingsId  : number;
    SavingsDemand  : number;
    DepositDate  : Date; 
    IsOpening: boolean;

    GroupLoanDemand : number ;  // Total Demands
    GroupSavingsDemand : number;
    GroupTotalDemand : number ; 
}
